export interface ChallengeSubmissionInput {
  ready: boolean;
  token: string | null;
  reset: () => void;
}

export interface ChallengeSubmissionLock {
  current: boolean;
}

export type ChallengeSubmissionResult<T> =
  | { started: true; value: T }
  | { started: false; reason: "locked" | "not_ready" };

export async function runChallengeSubmission<T>(
  challenge: ChallengeSubmissionInput,
  lock: ChallengeSubmissionLock,
  request: (token: string) => Promise<T>,
): Promise<ChallengeSubmissionResult<T>> {
  if (lock.current) return { started: false, reason: "locked" };
  if (!challenge.ready || challenge.token === null) return { started: false, reason: "not_ready" };

  lock.current = true;
  const token = challenge.token;

  try {
    return { started: true, value: await request(token) };
  } finally {
    challenge.reset();
    lock.current = false;
  }
}
